<template>
  <div class="big-box">
    <div class="scroll-box">
      <img :src="bgUrl" alt="" class="big-box-img" />
      <div class="big-body">
        <img :src="tapTopUrl" alt="" class="tap-top" />
        <div class="pd8">
          <!-- 主题文字 -->
          <div
            class="theme-word"
            v-if="currentIndex == 1"
            :style="`color: ${customerPaperwork.titleColor};`"
          >
            <div class="title">{{ customerPaperwork.title }}</div>
            <div class="desc">{{ customerPaperwork.desc }}</div>
          </div>
          <template v-if="currentIndex == 1">
            <div class="prize-box">
              <img class="region-icon-left" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/region-icon.png" alt="">
              <img class="region-icon-right" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/region-icon.png" alt="">
              <div class="prize-header" :style="prizeStyle">{{ customerPaperwork.prizeBtnText }}</div>
              <div class="prize-wrap" v-if="prizeList.length > 0">
                <div class="prize-content">
                  <img
                    v-if="currentPrizeData.logo"
                    :src="currentPrizeData.logo"
                    alt=""
                    class="prize-img"
                  />
                  <div class="prize-num" v-if="customerPaperwork.isShowInventory">
                    剩余{{ currentPrizeData.totalAmount }}件
                  </div>
                </div>
                <div class="prize-name">
                  {{ currentPrizeData.title }}
                </div>
                <div class="prize-price" v-if="currentPrizeData.price&&customerPaperwork.isShowPrice">
                  ￥{{ currentPrizeData.price }}
                </div>
                <div class="prize-indicators">
                  <span
                    v-for="(item, index) in prizeList"
                    :key="index"
                    :class="[
                      'indicator-dot',
                      currentPrizeIndex === index ? 'active' : '',
                    ]"
                  ></span>
                </div>
              </div>
            </div>
            <costomPreviwBtn
              v-if="currentIndex == 1"
              class="win-box"
              :btnUrl="btnUrl"
              :btnSize="btnSize"
              :btnText="customerPaperwork.btnText"
              :btnTextStyle="btnTextStyle"
            />
          </template>
          <template v-else-if="currentIndex == 2">
            <div class="answer-box" :style="answerStyle">
              <el-progress
                type="circle"
                :width="43"
                class="answer-progress"
                :percentage="100"
                :format="(per) => questions.length"
                :color="customerPaperwork.rgb8"
              ></el-progress>
              <div class="answer-title">
                共{{ questions.length }}道题，答对{{
                  ruleDTO.answerMode == 0
                    ? ruleDTO.correctScore + "分"
                    : ruleDTO.correctItem + "题"
                }}即可参与{{ prizeText }}
              </div>
              <div class="answer-header">
                <div>
                  <span class="finish-num">1</span
                  ><span class="total-quest">/{{ questions.length }}</span>
                </div>
                <div class="down-time">
                  <span class="time-text">倒计时</span>
                  <span class="time-num">03:59</span>
                </div>
              </div>
              <div class="progress-box">
                <el-progress
                  :percentage="10"
                  :color="customerPaperwork.rgb8"
                  :show-text="false"
                ></el-progress>
              </div>
              <div class="quest-box" v-if="questions.length > 0">
                <div class="quest-type">
                  {{ questionType(questionObj.type) }}
                </div>
                <div class="quest-title">{{ questionObj.title }}</div>
                <img
                  :src="questionObj.questionPicUrl"
                  v-if="(questionObj.type == 1 || questionObj.type == 2)&&questionObj.questionPicUrl"
                  alt=""
                  class="quest-img"
                />
                <div
                  class="options-list"
                  v-if="questionObj.type == 1 || questionObj.type == 2"
                >
                  <div
                    class="options-item"
                    v-for="(item, index) in questionObj.options"
                    :key="index"
                    :style="
                      item.isCorrect ? selectQuestStyle : noSelectQuestStyle
                    "
                  >
                    <span> {{ item.description }}</span>
                    <img
                      :src="selectUrl"
                      alt=""
                      class="correct"
                      v-if="item.isCorrect"
                    />
                  </div>
                </div>
                <div class="options-img" v-else>
                  <div
                    class="img-item"
                    v-for="(item, index) in questionObj.options"
                    :key="index"
                  >
                    <img :src="item.picUrl" alt="" class="img-url" />
                    <img
                      :src="selectUrl"
                      alt=""
                      class="correct"
                      v-if="item.isCorrect"
                    />
                    <div class="img-mock" v-if="item.isCorrect"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="next-quest" @click="nextQuest">下一题</div>
          </template>
          <template v-else>
            <div class="result-box" :style="resultStyle">
              <img :src="answerRightUrl" class="result-right" alt="" />
              <div class="result-title">答题结束</div>
              <div class="result-desc">
                恭喜你，题日答对超{{
                  ruleDTO.answerMode == 0
                    ? ruleDTO.correctScore + "分"
                    : ruleDTO.correctItem + "题"
                }}，马上去{{ prizeText }}吧~
              </div>
              <div class="rate-box">
                <el-progress
                  type="dashboard"
                  :percentage="98"
                  :width="149"
                  :stroke-width="8"
                  :show-text="false"
                  :color="customerPaperwork.rgb8"
                ></el-progress>
                <div class="rate-text">
                  <div class="rate-title">正确率</div>
                  <div class="rate-num">
                    <span class="percent-num">98</span>
                    <span class="percent">%</span>
                  </div>
                </div>
              </div>
              <div class="footer-box">
                <div class="footer-item active1">
                  <div class="footer-num">70分</div>
                  <div>正确题</div>
                  <div>5</div>
                </div>
                <div class="footer-item active2">
                  <div class="footer-num">70分</div>
                  <div>错误题</div>
                  <div>4</div>
                </div>
                <div class="footer-item active3">
                  <div class="footer-num">70分</div>
                  <div>未答题</div>
                  <div>1</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="footer-title">图为预览效果，以实际投效果为准</div>
    <div class="page-select">
      <div
        :class="['page-item', currentIndex === item.id ? 'select-active' : '']"
        v-for="item in pageSetting"
        :key="item.id"
        @click="handleChange(item.id)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>
<script>
import costomPreviwBtn from "@/views/interactiveMarketing/activity/components/commCustomizationSet/costomPreviwBtn.vue";
export default {
  name: "",
  components: {
    costomPreviwBtn,
  },
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    prizeList: {
      type: Array,
      default: () => [],
    },
    questions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentQuest: 0,
      questionObj: {
        type: 1,
        title: "",
        options: [],
      },
      btnSize: {
        width: "167px",
        height: "38px",
      },
      currentIndex: 1,
      pageSetting: [
        {
          id: 1,
          title: "主页面",
        },
        {
          id: 2,
          title: "答题页",
        },
        {
          id: 3,
          title: "结果页",
        },
      ],
      currentObj: {},
      currentPrize: [],
      currentPrizeIndex: 0,
      prizeTimer: null,
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
    };
  },
  computed: {
    btnUrl() {
      return this.customerPaperwork.url2
        ? this.customerPaperwork.url2
        : this.templateObj.url2;
    },
    bgUrl() {
      const conJson = this.templateObj.configJson
        ? JSON.parse(this.templateObj.configJson)
        : { url6: "" };
      console.log(this.templateObj, "65656");
      return this.currentIndex == 1
        ? this.backgroundImage
        : this.currentIndex == 2
        ? this.customerPaperwork.url4 || this.templateObj.url4
        : this.customerPaperwork.url6 || conJson.url6;
    },
    selectUrl() {
      return this.customerPaperwork.url5
        ? this.customerPaperwork.url5
        : this.templateObj.url5;
    },
    currentPrizeData() {
      return this.prizeList.length > 0
        ? this.prizeList[this.currentPrizeIndex]
        : {
            title: "",
            price: "",
            totalAmount: "",
            logo: "",
          };
    },
    answerStyle() {
      return {
        width: "256px",
        height: "450px",
        background: `url(https://cdn-image.yucrm.cn/fe87c81181664f5a8ee716fcf873bfbd.png) no-repeat center center`,
        backgroundSize: "100% 100%",
      };
    },
    resultStyle() {
      return {
        width: "260px",
        height: "415px",
        background: `url(https://cdn-image.yucrm.cn/47e63d1499294033957282eee0b5c516.png) no-repeat center center`,
        backgroundSize: "100% 100%",
      };
    },
    prizeText() {
      return this.ruleDTO.awardType == 1 ? "抽奖" : "领奖";
    },
    noSelectQuestStyle() {
      return {
        backgroundColor: this.customerPaperwork.rgb4,
        color: this.customerPaperwork.rgb5,
      };
    },
    selectQuestStyle() {
      return {
        backgroundColor: this.customerPaperwork.rgb6,
        color: this.customerPaperwork.rgb7,
      };
    },
    answerRightUrl() {
      const conJson = this.templateObj.configJson
        ? JSON.parse(this.templateObj.configJson)
        : { url7: "" };
      return this.customerPaperwork.url7 || conJson.url7;
    },
    prizeStyle() {
      return {
        background: `url(${this.customerPaperwork.url3||this.templateObj.url3}) no-repeat`,
        backgroundSize: "100% 100%",
        color: this.customerPaperwork.rgb3,
      };
    },
    btnTextStyle() {
      return {
        color: this.customerPaperwork.rgb2,
      }
    }
  },
  watch: {
    prizeList: {
      handler(newVal, oldVal) {
        if (this.currentIndex == 1 && newVal.length > 1) {
          clearInterval(this.prizeTimer);
          this.startPrizeAutoSwitch();
        }
      },
      immediate: true,
      deep: true,
    },
    questions: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.questionObj = newVal[0];
          this.currentQuest = 0;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  beforeDestroy() {
    if (this.prizeTimer) {
      clearInterval(this.prizeTimer);
    }
  },
  methods: {
    nextQuest() {
      if (this.currentQuest >= this.questions.length - 1) {
        return;
      } else {
        this.currentQuest++;
      }
      this.questionObj = this.questions[this.currentQuest];
    },
    // 题目类型
    questionType(type) {
      const typeMap = {
        1: "单选题",
        2: "多选题",
        4: "图片单选题",
        5: "图片多选题",
      };
      return typeMap[type] || "";
    },
    startPrizeAutoSwitch() {
      this.prizeTimer = setInterval(() => {
        this.currentPrizeIndex =
          (this.currentPrizeIndex + 1) % this.prizeList.length;
      }, 2000);
    },
    handleChange(index) {
      this.currentIndex = index;
    },
    // 将十六进制颜色转换为rgba格式，支持透明度设置，透明度不影响子元素
    hexToRgba(hex, opacity) {
      if (!hex) return "rgba(255,255,255,1)";
      // 处理简写形式 #fff => #ffffff
      let color = hex.replace("#", "");
      if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      const a = opacity / 100;
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    },
    // 自定义仪表盘进度条文案
    formatProgress(percentage) {
      return `<div class="progress-label">正确率</div><div class="progress-value">${percentage}<span class="progress-unit">%</span></div>`;
    },
  },
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;

  .scroll-box {
    position: relative;
    width: 284px;
    height: 560px;
    overflow: auto;
    border-radius: 24px;
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
    .layout-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .big-box-img {
    border-radius: 24px;
    width: 100%;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tap-top {
      width: 100%;
    }
    .pd8 {
      position: absolute;
      top: 20px;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      position: relative;
      .theme-word {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        > div:first-child {
          height: 16px;
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 10px;
        }
        > div:last-child {
          margin: 0 auto;
          text-align: center;
          width: 65%;
          height: 11px;
          line-height: 12px;
          font-size: 11px;
        }
      }
      .prize-box {
        position: relative;
        width: 245px;
        height: 292px;
        margin: 30px auto;
        background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/prize-region-bg.png") no-repeat;
        background-size: 100% 100%;
        // background: #ffffff;
        border-radius: 24px;
        // overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        .region-icon-left {
          position: absolute;
          top: -12px;
          left: 8px;
          width: 30px;
          height: 30px;
        }
        .region-icon-right {
          position: absolute;
          top: -12px;
          right: 8px;
          width: 30px;
          height: 30px;
        }
        .prize-header {
          // margin: 0 auto;
          width: 117px;
          height: 27px;
          line-height: 27px;
          text-align: center;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          color: #000000;
          font-size: 14px;
        }
        .prize-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          .prize-content {
            width: 138px;
            height: 138px;
            margin-top: 24px;
            // margin: 24px auto;
            position: relative;
            border-radius: 12px;

            .prize-img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 12px;
            }
            .prize-num {
              position: absolute;
              top: 0;
              left: 0;
              // width: 56px;
              padding: 0 8px;
              height: 18px;
              font-size: 9px;
              background: rgba(0, 0, 0, 0.5);
              border-radius: 9px 0px 9px 0px;
              color: #ffffff;
              text-align: center;
              line-height: 18px;
            }
          }
          .prize-name {
            margin-top: 16px;
            width: 209px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 11px;
            color: #1a1a1a;
            line-height: 11px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            // 一行显示，超出部分省略号
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .prize-price {
            margin-top: 9px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 10px;
            color: #ff384c;
            line-height: 10px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
          .prize-indicators {
            margin-top: 8px;
            display: flex;
            justify-content: center;
            gap: 4px;
            .indicator-dot {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: #cccccc;
              transition: all 0.3s ease;
              &.active {
                background-color: #000000;
              }
            }
          }
        }
      }
      .win-box {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 335px;
      }
      .answer-box {
        position: relative;
        margin: 0 auto;
        overflow: hidden;
        padding: 0 16px;
        .answer-progress {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          width: 43px;
          height: 43px;
        }
        .answer-title {
          text-align: center;
          margin-top: 59px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 10px;
          color: #000000;
          line-height: 10px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .answer-header {
          margin-top: 45px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          .finish-num {
            font-family: D-DIN Exp-DINExp, D-DIN Exp-DINExp;
            color: #1a1a1a;
            font-size: 16px;
          }
          .total-quest {
            font-family: D-DIN Exp-DINExp, D-DIN Exp-DINExp;
            color: #1a1a1a;
            font-size: 9px;
          }
          .down-time {
            padding: 7px 10px;
            background: #efefef;
            border-radius: 25px;
            display: flex;
            align-items: center;
            .time-text {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 8px;
              color: #000000;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
            .time-num {
              margin-left: 2px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 12px;
              color: #000000;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
          }
        }
        .progress-box {
          margin-top: 8px;
        }
        .quest-box {
          max-height: 250px;
          margin-top: 26px;
          overflow-y: auto;
          &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
          }
          .quest-type {
            width: fit-content;
            padding: 2px 3px;
            background: #f0ddba;
            border-radius: 2px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 9px;
            color: #000000;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          .quest-title {
            margin-top: 6px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #1a1a1a;
            line-height: 12px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          .quest-img {
            margin-top: 12px;
            width: 100%;
            height: auto;
          }
          .options-list {
            margin-top: 12px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .options-item {
              position: relative;
              margin-bottom: 9px;
              width: 229px;
              height: 33px;
              background: #fcf9f2;
              border-radius: 25px;
              text-align: center;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 10px;
              color: #1a1a1a;
              line-height: 33px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              .correct {
                width: 22px;
                height: 22px;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 11px;
                z-index: 1;
              }
            }
          }
          .options-img {
            margin-top: 12px;
            display: grid;
            // 两列展示
            grid-template-columns: 1fr 1fr;
            grid-gap: 12px;
            .img-item {
              position: relative;
              border-radius: 6px;
              .img-url {
                width: 100%;
                height: 100px;
                border-radius: 6px;
              }
              .correct {
                width: 22px;
                height: 22px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 11;
              }
              .img-mock {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.5);
                border-radius: 6px;
              }
            }
          }
        }
      }
      .next-quest {
        margin: 16px auto;
        width: 33px;
        text-align: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 11px;
        color: #333333;
        line-height: 11px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .result-box {
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 13px 20px;
        .result-right {
          width: 83px;
          height: 83px;
        }
        .result-title {
          margin-top: 9px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 12px;
          color: #000000;
          line-height: 12px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .result-desc {
          margin-top: 9px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 10px;
          color: #666666;
          line-height: 10px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .rate-box {
          position: relative;
          margin-top: 54px;
          width: 149px;
          height: 75px;
          overflow: hidden;
          .rate-text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 10px;
            .rate-title {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 10px;
              color: #000000;
              line-height: 10px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            .rate-num {
              margin-top: 6px;
              .percent-num {
                font-family: D-DIN-PRO, D-DIN-PRO;
                font-weight: 800;
                font-size: 24px;
                color: #000000;
                line-height: 24px;
                text-align: center;
                font-style: normal;
                text-transform: none;
              }
              .percent {
                font-size: 9px;
                color: #999999;
              }
            }
          }
        }
        .footer-box {
          margin-top: 30px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .footer-item {
            position: relative;
            width: 66px;
            height: 67px;
            border-radius: 9px;
            .footer-num {
              position: absolute;
              width: 40px;
              height: 13px;
              border-radius: 0 0 8px 8px;
              top: 0px;
              left: 50%;
              transform: translateX(-50%);
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 9px;
              color: #ffffff;
              line-height: 13px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              background: rgba(0,0,0,0.3);
            }
            > div:nth-child(2) {
              margin-top:22px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 9px;
              color: #000000;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            > div:nth-child(3) {
              margin-top: 9px;
              font-family: D-DIN-PRO, D-DIN-PRO;
              font-weight: 600;
              font-size: 18px;
              color: #000000;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
          .active1 {
            background: #f9fef0;
          }
          .active2 {
            background: #fdf6f5;
          }
          .active3 {
            background: #fefbf0;
          }
        }
      }
    }
  }
  .page-select {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #cbcfd6;
    border-radius: 8px;
    .page-item {
      width: 33.3%;
      padding: 10px 0;
      text-align: center;
      border-left: 1px solid #cbcfd6;
      cursor: pointer;
      &:first-child {
        border-left: none;
      }
    }
    .select-active {
      color: #3159ff;
    }
  }
  .footer-title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
}
</style>
